import React, { useState } from "react";
import { Row, Col, Tooltip } from "reactstrap";
import { Link } from "react-router-dom";
import { FooterForm } from "../../api/smtpEmailService"
import "../../assets/css/footer.css"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
    const [tooltipOpen, setTooltipOpen] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [responseMsg, setResponseMsg] = useState(null);

    const toggleTooltip = (id) => {
        setTooltipOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMsg(null);

        try {
            const result = await FooterForm(formData);

            if (result.success || result.Success) {
                toast.success(result.message || result.Message, {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
                setFormData({ name: "", email: "", message: "" });
            } else {
                toast.error("Failed to send message", {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
            }
        } catch (error) {
            toast.error("Something went wrong!", {
                theme: "colored",
                position: "top-right",
                autoClose: 3000
            });
        }


        setLoading(false);
    };

    return (
        <>
            <div className="footer-wrapper">
                <footer className="text-dark pt-5 px-2 footer-container">
                    <div className="top-section">
                        <Row className="pt-4">

                            {/* FORM Column */}
                            <Col lg={4} md={6} className="">
                                <h6 className="text-uppercase fw-medium text-muted mb-3">Let's Do Business</h6>
                                <form>
                                    <Row className="p-0">
                                        <Col sm={6}>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm border-primary bg-transparent big-input mb-3"
                                                placeholder="Your Name"
                                                value={formData.name}
                                                name="name"
                                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm border-primary bg-transparent big-input mb-3"
                                                placeholder="example@email.com"
                                                value={formData.email}
                                                name="email"
                                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            />
                                        </Col>
                                    </Row>

                                    <div className="mb-3">
                                        <textarea
                                            className="form-control form-control-sm border-primary bg-transparent big-textarea"
                                            rows="5"
                                            placeholder="Your Message Here"
                                            value={formData.message}
                                            name="message"
                                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="primary-button fs-6 btn-sm"
                                        id="send-btn"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "SEND MESSAGE"}
                                    </button>
                                    <ToastContainer position="top-right" newestOnTop />
                                </form>
                            </Col>

                            {/* CONTACT US Column */}
                            <Col lg={4} md={6} className="mb-4 fs-6 footer-form">
                                <h6 className="text-uppercase fw-medium text-muted mb-3">Contact Us</h6>
                                {/*<div className="mt-2">*/}
                                {/*    <h6 className="text-uppercase footer-sub-heading fw-medium text-muted mb-3">SPEAK TO US</h6>*/}
                                {/*</div>*/}
                                <div className="mb-1">
                                    <Link to="tel:+912261680000" className="footer-contact text-dark">
                                        TEL: +91-22-6168 0000
                                    </Link>
                                </div>

                                <div className="mb-3">
                                    <Link to="tel:+912261815353" className="footer-contact text-dark">
                                        FAX: +91-22-6181 5353
                                    </Link>
                                </div>

                                <div className="small fs-6">
                                    <div className="mb-1">
                                        <h6 className="text-uppercase fw-medium footer-sub-heading text-muted mb-3">VISIT US</h6>
                                    </div>
                                    <div className="mb-3">
                                        <Link
                                            to="https://maps.app.goo.gl/1vmFcePTHDc8dhXD7?g_st=aw"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="footer-contact text-decoration-none text-dark"
                                        >
                                            <div>204, Brahans Business Centre,</div>
                                            <div>Mahakali Caves Road, Andheri East,</div>
                                            <div>Mumbai, Maharashtra - 400093</div>
                                        </Link>
                                    </div>
                                </div>
                            </Col>

                    {/* COMPANY LINKS Column */}
                    <Col lg={4} md={6} className="mb-4">
                        <h6 className="text-uppercase fw-medium text-muted mb-3">Company Links</h6>
                        <div className="row">
                            <Col sm={6}>
                                <div className="small fs-6 text-black">
                                    <div className="mb-2">
                                        <Link to="/" className="text-dark text-decoration-none">Home </Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/about-us" className="text-dark text-decoration-none">About Us</Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link
                                            id="qa-whyus"
                                            to="/why-us"
                                            onClick={(e) => e.preventDefault()}
                                            className="text-dark"
                                        >
                                            Why Us
                                        </Link>
                                        <Tooltip
                                            fade={false}
                                            placement="right"
                                            isOpen={!!tooltipOpen["qa-whyus"]}
                                            target="qa-whyus"
                                            toggle={() => toggleTooltip("qa-whyus")}
                                        >
                                            Available Soon
                                        </Tooltip>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/product-range" className="text-dark text-decoration-none">Products</Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/services" className="text-dark text-decoration-none">Services</Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link
                                            id="qa-manufacturing"
                                            to="/manufacturing"
                                            onClick={(e) => e.preventDefault()}
                                            className="text-dark"
                                        >
                                            Manufacturing
                                        </Link>
                                        <Tooltip
                                            fade={false}
                                            placement="right"
                                            isOpen={!!tooltipOpen["qa-manufacturing"]}
                                            target="qa-manufacturing"
                                            toggle={() => toggleTooltip("qa-manufacturing")}
                                        >
                                            Available Soon
                                        </Tooltip>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/contact-us" className="text-dark text-decoration-none">Contact Us</Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/terms-condition" className="text-dark text-decoration-none">Terms & conditions</Link>
                                    </div>
                                    <div className="mb-2">
                                        <Link to="/privacy-policy" className="text-dark text-decoration-none">Privacy Policy</Link>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Col>

                        </Row>
                    </div>

                    {/* Middle Section: LOGO | SOCIAL ICONS */}
                    <div className="border-bottom border-2">
                        <div className="row">
                            <Row className="p-0 align-items-center">
                                {/* LOGO */}
                                <Col lg={6} md={6} className="p-0 mb-2">
                                    <Link to="/" className="text-decoration-none">
                                        <img
                                            src="/assets/images/Logo/Logo_dark.png"
                                            className="logo-link"
                                            alt="logo"
                                        />
                                    </Link>
                                </Col>

                                {/* SOCIAL ICONS */}
                                <Col lg={6} md={6} className="mb-2">
                                    <div className="d-flex flex-column align-items-md-end">

                                        {/* Proper Heading */}
                                        <div className="fw-semibold mb-2 text-md-end social-heading">
                                            Follow Us on Social Media
                                        </div>

                                        {/* Social Icons */}
                                        <div className="d-flex gap-3">

                                            <span id="fb-tooltip" onClick={(e) => e.preventDefault()}>
                                                <i className="bx bxl-facebook-square fs-3"></i>
                                            </span>
                                            <Tooltip placement="top" isOpen={!!tooltipOpen["fb"]} target="fb-tooltip" toggle={() => toggleTooltip("fb")}>
                                                Available Soon
                                            </Tooltip>

                                            <a
                                                href="https://www.instagram.com/meera_jewelleryhouse/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none text-dark"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="bx bxl-instagram-alt fs-3"></i>
                                            </a>

                                            <a
                                                href="https://www.linkedin.com/company/meera-jewellery-house-llp"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none text-dark"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="bx bxl-linkedin-square fs-3"></i>
                                            </a>
                                        </div>

                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    {/* Bottom Section: COPYRIGHT LINE */}
                    <div className="row">
                        <Row className="py-3">
                            <Col className="text-start d-flex">
                                <div className="footer-bottom text-dark">
                                    &copy; 2025. Meera Jewellery House. Built with
                                    <i className="bx bxs-heart text-danger mx-1"></i>
                                    by&nbsp;
                                    <a href="https://axoneit.com/"
                                        className="text-decoration-none text-dark fw-semibold"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        Axone Infotech India
                                    </a>.
                                    All Rights Reserved.
                                </div>
                            </Col>
                        </Row>
                    </div>
                </footer>
            </div >
        </>
    );
};

export default Footer;